import React, { useState, useEffect, useRef } from "react";

import { Tooltip } from "@mui/material";

import {
  CompanyProfileNameOption,
  ProfileCompany,
  UserCompanyLogo,
  ProfileCompanyOptionIconUp,
  ProfileCompanyOptionIconDown,
  CompanyProfileName,
  CompanyAndProfileNameContainer,
} from "./styles";
import { CompanyNameAndIconContainerProps } from "../types";

export const CompanyNameAndIconContainer = ({
  company,
  displayChevron = false,
  showCompanyOptions = false,
  showProfileName = false,
}: CompanyNameAndIconContainerProps) => {
  const [isEllipsed, setIsEllipsed] = useState(false);

  const textElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textElementRef?.current?.scrollWidth && textElementRef?.current?.clientWidth) {
      setIsEllipsed(textElementRef?.current?.scrollWidth > textElementRef?.current?.clientWidth);
    }
  }, []);

  const renderProfileCompanyIcon = () => {
    if (!displayChevron) return null;

    return showCompanyOptions ? (
      <ProfileCompanyOptionIconUp color="#667085" />
    ) : (
      <ProfileCompanyOptionIconDown color="#667085" />
    );
  };

  const renderCompanyProfileName = () => {
    if (!showProfileName) return null;

    return <CompanyProfileName>{company?.profile?.name || ""}</CompanyProfileName>;
  };

  return (
    <ProfileCompany container direction="row">
      {company?.icon?.mediaLink && (
        <UserCompanyLogo src={company?.icon?.mediaLink} alt="company icon" />
      )}

      <Tooltip title={company?.name || ""} placement="top" disableHoverListener={!isEllipsed}>
        <CompanyAndProfileNameContainer>
          <CompanyProfileNameOption
            displayChevron={displayChevron}
            hasIcon={!!company?.icon?.mediaLink}
            ref={textElementRef}
          >
            {company?.name}
          </CompanyProfileNameOption>

          {renderCompanyProfileName()}
        </CompanyAndProfileNameContainer>
      </Tooltip>

      {renderProfileCompanyIcon()}
    </ProfileCompany>
  );
};
